import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import "./Contact.css";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  // handling form submission
  const onFormSubmit = (event) => {
    event.preventDefault();
    const newUser = {
      name,
      email,
      phone,
      message,
    };
    console.log(newUser);
  };

  return (
    <form onSubmit={onFormSubmit}>
      <h1>Get In Touch</h1>
      <input
        type="text"
        placeholder="Name*"
        value={name}
        className="input-field"
        onChange={(e) => setName(e.target.value)}
      />
      <span className="text-danger"></span>

      <input
        type="email"
        placeholder="Email*"
        value={email}
        className="input-field"
        onChange={(e) => setEmail(e.target.value)}
      />
      <span className="text-danger"></span>

      <input
        type="tel"
        placeholder="Phone"
        value={phone}
        className="input-field"
        onChange={(e) => setPhone(e.target.value)}
      />
      <span className="text-danger"></span>

      <textarea
        name="message"
        id="message"
        value={message}
        cols="30"
        rows="2"
        placeholder="Message*"
        onChange={(e) => setMessage(e.target.value)}
      ></textarea>
      <span className="text-danger"></span>
      <button className="submit-btn" type="submit">
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
